import { ERROR_MESSAGES, internalErrorMessageMap } from './constants';
import * as ErrorServiceUtil from './errorMessageProcessing';
import * as SimplrErrors from '@asurion-core/typescript-utils/SimplrErrors';
import HttpStatus from 'http-status-codes';
import { CloudFunctionRequestError } from '@asurion-core/frontend-utils/lib/ErrorsModule/ErrorsModule';

export const processErrorMessage = (error, message) => {
  if (SimplrErrors.SimplrError.isSimplrError(error)) {
    return ErrorServiceUtil.processSimplrErrorMessage(error);
  }

  const responseError = error?.response;

  if (error instanceof CloudFunctionRequestError && SimplrErrors.SimplrError.isSimplrError(responseError)) {
    return ErrorServiceUtil.processSimplrErrorMessage(responseError);
  }

  return ErrorServiceUtil.processNetworkErrorMessage(error, message);
};

export const processSimplrErrorMessage = (error) => {
  if (error.code === SimplrErrors.Codes.AUTHENTICATION_ERROR || error.status === HttpStatus.UNAUTHORIZED) {
    return ERROR_MESSAGES.SESSION_IS_INVALID;
  }

  if (error.message === ERROR_MESSAGES.CASE_LOCKED) {
    return ERROR_MESSAGES.TICKET_LOCKED;
  }

  if (error.message.includes(ERROR_MESSAGES.PERSON_UNAVAILABLE)) {
    return ERROR_MESSAGES.PERSON_UNAVAILABLE;
  }

  return internalErrorMessageMap[error.code] ?? error.message;
};

/** Show an error generated by the Express backend
 * @param  {object} error
 * @param {string} message
 * @returns {function}
 */
export const processNetworkErrorMessage = (error, message) => {
  switch (error?.status) {
    case 423:
      return ERROR_MESSAGES.PROCESSING_FAILED;
    case 429:
      return ERROR_MESSAGES.PROCESSING_FAILED_LONG_RETRY;
    default:
      return message || ERROR_MESSAGES.DEFAULT;
  }
};
